const AdvisorLayout = <template>{{outlet}}</template>;

export default AdvisorLayout;
